import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../../store';
import SliderListItem from '../../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../../store/extensions';

const ImageElementShadowAngleListItem = (props) => {
    const { shadowSettingsAngle, updateImageElement, index } = props;

    const onShadowAngleChange = (value) => {
        previewHistoryBatch.start();
        updateImageElement(index, { shadowSettings: { angle: value } });
    };

    return (
        <SliderListItem
            title='Angle'
            value={shadowSettingsAngle}
            min={0}
            max={360}
            step={1}
            onValueChange={onShadowAngleChange}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const imageElement = (state.createPreview.present.videoSettings.elements.imageElements || state.createPreview.present.videoSettings.elements.images)[ownProps.index];
    const shadowSettings = imageElement?.shadowSettings || {};
    return { shadowSettingsAngle: shadowSettings.angle };
}

const mapDispatchToProps = (dispatch) => {
    const updateImageElement = (index, properties) => dispatch(createActions.updateImageElement(index, properties));
    return { updateImageElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageElementShadowAngleListItem);
